import { render } from "./OidcCallback.vue?vue&type=template&id=a0470192"
import script from "./OidcCallback.vue?vue&type=script&lang=js"
export * from "./OidcCallback.vue?vue&type=script&lang=js"

import exportComponent from "/builds/websites/koch-bus-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__